import React from "react";
import { videos } from "./videos";

function VideosSection() {
  return (
   <section className="bg-[#eaebec] w-full">
     <div className="text-black py-20 w-full max-w-[1280px] mx-auto px-4 2xl:px-0">
      {/* Section Header */}
      <div className="flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl my-2">Videos</h2>
          <div className="border-b-4 border-green-600 w-16 mx-auto" />
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-wrap justify-evenly mx-auto mt-6 gap-4 p-3">
        {videos.map((video, index) => (
          <div key={index} className="flex justify-center">
            <iframe
              src={video.src}
              frameBorder="0"
              width={325}
              height={250}
              allow="autoplay; encrypted-media"
              allowFullScreen
              title={`video-${index}`}
              className="rounded"
            />
          </div>
        ))}
      </div>
    </div>
   </section>
  );
}

export default VideosSection;
